import { AdminRoleId } from '@tassat/common-definitions';
import { AccountClientGroupRecord, UserRecord } from '@tassat/fred-definitions';
import { AdminUserRecordMapped, UserRecordRoleDisplay } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getAcgUsersArray } from './acgUsers';
import { getAccountClientGroups, getUserRoles, getUsers } from './common';

const getUserId = (_state: AdminState | ClientState, userId: string, _includeDeleted: boolean, _pcgId: string, _firmId: string) => userId;
const getFirmId = (_state: AdminState | ClientState, _userId: string, _includeDeleted: boolean, _pcgId: string, firmId: string) => firmId;

export const getUserById = createSelector([ getUsers, getUserId ], (users, userId): UserRecord => {
    return users[userId] || {} as UserRecord;
});

export const getClientUsers = createSelector([getUsers], (users): UserRecord[] => {
    return Object.keys(users)
        .filter(UserId => (!users[UserId].IsAdmin && !users[UserId].IsDeleted))
        .map(UserId => users[UserId]);
});

export const getUsersByFirmId = createSelector([ getUsers, getFirmId ], (users, firmId) => {
    return Object.keys(users)
        .map(id => users[id])
        .filter(user => !user.IsDeleted && !user.IsAdmin && user.FirmId === firmId);
});

export const getAdminUsersWithRoleDisplay = createSelector([ getUsers, getUserRoles ], (users, userRoles) => {
    return Object.keys(users)
        .filter(UserId => (users[UserId].IsAdmin && !users[UserId].IsDeleted))
        .map(UserId => {
            const user: UserRecordRoleDisplay = { ...users[UserId] };
            if (userRoles && userRoles.length > 0) {
                const role = userRoles.find(role => role.AdminRoleId === user.AdminRoleId);
                user.UserRoleDisplay = role ? role.DisplayName : '';
            }

            return user;
        });
});

export const getAdminUserMapped = createSelector(
    [ getUsers, getUserRoles, getAccountClientGroups, getAcgUsersArray, getUserId ],
    (users, userRoles, accountClientGroups, acgUsersArray, userId): AdminUserRecordMapped => {
        const user: AdminUserRecordMapped = users[userId];
        if (!user) return {} as AdminUserRecordMapped;

        let AcgMapping = [] as AccountClientGroupRecord[];
        const role = userRoles.find(role => role.AdminRoleId === user.AdminRoleId);

        if (role && role.AdminRoleId === AdminRoleId.PCG_ADMIN) {
            AcgMapping = acgUsersArray
                .filter(acgUser => acgUser.UserId === userId)
                .map(acgUser => accountClientGroups[acgUser.ACGId]);
        }

        return {
            ...user,
            UserRoleDisplay: role ? role.DisplayName : '',
            AcgMapping
        };
    }
);